import React from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import BaseComponent from 'components/BaseComponent';
import styledComp from 'components/StyledComp';
import DataTables from 'components-desktop/DataTables';

const propTypes = {
  title: PropTypes.string,
  patients: PropTypes.array,
  patientContracts: PropTypes.array,
};

const defaultProps = {
  title: '',
  patients: [],
  patientContracts: [],
};

@autobind
class TablePatientsVcs extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  createColumns() {
    return [{
      title: 'ID',
      dataIndex: 'id',
      sorter: (a, b) => a.id - b.id,
    }, {
      title: 'Patient ID',
      dataIndex: 'altPatientId',
      sorter: (a, b) => a.altPatientId?.localeCompare(b.altPatientId),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/patients/patient_profile?id=${record.id}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }, {
      title: 'Status',
      dataIndex: 'applyStatus',
      sorter: (a, b) => a.applyStatus?.localeCompare(b.applyStatus),
      render: (text, record) => (
        <styledComp.Span
          width="wrap_content"
          height="wrap_content"
          color={record.applyStatus === 'Approved' ? 'green' : 'textPrimaryDark'}
          fontSize="12px"
        >
          {text}
        </styledComp.Span>
      ),
    }, {
      title: 'Latest Company',
      dataIndex: 'latestCompany',
      sorter: (a, b) => a.latestCompany?.localeCompare(b.latestCompany),
    }, {
      title: 'Medicaid #',
      dataIndex: 'medicaidNo',
      sorter: (a, b) => a.medicaidNo?.localeCompare(b.medicaidNo),
    }, {
      title: 'Medicare #',
      dataIndex: 'medicareNo',
      sorter: (a, b) => a.medicareNo?.localeCompare(b.medicareNo),
    }, {
      title: 'First Name',
      dataIndex: 'firstName',
      sorter: (a, b) => a.firstName?.localeCompare(b.firstName),
    }, {
      title: 'Middle Name',
      dataIndex: 'middleName',
      sorter: (a, b) => a.middleName?.localeCompare(b.middleName),
    }, {
      title: 'Last Name',
      dataIndex: 'lastName',
      sorter: (a, b) => a.lastName?.localeCompare(b.lastName),
      defaultSortOrder: 'ascend',
    }, {
      title: 'Date of Birth',
      dataIndex: 'birthUsString',
      sorter: (a, b) => a.birth - b.birth,
    }, {
      title: 'Language',
      dataIndex: 'language',
      sorter: (a, b) => a.language?.localeCompare(b.language),
    }, {
      title: 'Gender',
      dataIndex: 'gender',
      sorter: (a, b) => a.gender?.localeCompare(b.gender),
    }, {
      title: 'Primary Language',
      dataIndex: 'language',
      sorter: (a, b) => a.language?.localeCompare(b.language),
    }, {
      title: 'Telephone',
      dataIndex: 'homePhone',
      sorter: (a, b) => a.homePhone?.localeCompare(b.homePhone),
    }, {
      title: 'Alternative Phone',
      dataIndex: 'cellPhone',
      sorter: (a, b) => a.cellPhone?.localeCompare(b.cellPhone),
    }, {
      title: 'Street',
      dataIndex: 'street',
      sorter: (a, b) => a.street?.localeCompare(b.street),
    }, {
      title: 'City',
      dataIndex: 'city',
      sorter: (a, b) => a.city?.localeCompare(b.city),
    }, {
      title: 'State',
      dataIndex: 'state',
      sorter: (a, b) => a.state?.localeCompare(b.state),
    }, {
      title: 'Zip code',
      dataIndex: 'zipCode',
      sorter: (a, b) => a.zipCode?.localeCompare(b.zipCode),
    }, {
      title: 'Remark',
      dataIndex: 'remark',
      sorter: (a, b) => a.remark?.localeCompare(b.remark),
    }, {
      title: 'Emergency contact name',
      dataIndex: 'emergContName',
      sorter: (a, b) => a.emergContName?.localeCompare(b.emergContName),
    }, {
      title: 'Emergency contact relationship',
      dataIndex: 'emergContRelation',
      sorter: (a, b) => a.emergContRelation?.localeCompare(b.emergContRelation),
    }, {
      title: 'Emergency phone #',
      dataIndex: 'emergContNumber',
      sorter: (a, b) => a.emergContNumber?.localeCompare(b.emergContNumber),
    }, {
      title: 'Service Start Date',
      dataIndex: 'serviceStartDateUsString',
      sorter: (a, b) => a.serviceStartDate - b.serviceStartDate,
    }, /*  {
      title: 'Days x Hours',
      dataIndex: 'daysHours',
      sorter: (a, b) => a.daysHours?.localeCompare(b.daysHours),
    }, */ {
      title: 'Caregiver',
      dataIndex: 'caregiver',
      sorter: (a, b) => a.caregiver?.localeCompare(b.caregiver),
      render: (text, record) => (
        <styledComp.A
          width="wrap_content"
          height="wrap_content"
          href={`/caregivers/caregiver_profile?id=${record.caregiverId}`}
          target="_blank"
        >
          {text}
        </styledComp.A>
      ),
    }];
  }

  createDataSource(patients, patientContracts) {
    const dataSource = [];
    patients.forEach((patient, index) => {
      dataSource.push({
        key: patient.getId(),
        id: patient.getId(),
        altPatientId: patientContracts[index]?.getString('altPatientId'),
        firstName: patient.getString('firstName'),
        middleName: patient.getString('middleName'),
        lastName: patient.getString('lastName'),
        latestCompany: patientContracts[index]?.getString('companyName'),
        gender: patient.getString('gender'),
        birth: patient.getLong('birth'),
        birthUsString: patient.getString('birthUsString'),
        medicaidNo: patient.getString('medicaidNo'),
        medicareNo: patient.getString('medicareNo'),
        homePhone: patient.getString('homePhone'),
        cellPhone: patient.getString('cellPhone'),
        emergContName: patient.getString('emergContName'),
        emergContRelation: patient.getString('emergContRelation'),
        emergContNumber: patient.getString('emergContNumber'),
        street: patient.getString('street'),
        city: patient.getString('city'),
        state: patient.getString('state'),
        zipCode: patient.getString('zipCode'),
        language: patient.getString('language'),
        remark: patient.getString('remark'),
        caregiver: patient.getString('caregiver'),
        caregiverId: patient.getLong('caregiverId'),
        applyStatus: this.e2t('applyStatus', patient.getString('applyStatus')),
        serviceStartDate: patientContracts[index]?.getLong('serviceStartDate'),
        serviceStartDateUsString: patientContracts[index]?.getString('serviceStartDateUsString'),
      });
    });
    return dataSource;
  }

  renderContent() {
    const { patients, patientContracts, title, ...layoutProps } = this.props;

    return (
      <DataTables
        {...layoutProps}
        color="blue_steel"
        fontSize="12px"
        size="small"
        title={title}
        icon="user"
        selectable={false}
        columns={this.createColumns()}
        dataSource={this.createDataSource(patients, patientContracts)}
      />
    );
  }
}

// https://facebook.github.io/react/docs/typechecking-with-proptypes.html
TablePatientsVcs.propTypes = propTypes;
TablePatientsVcs.defaultProps = defaultProps;

export default TablePatientsVcs;
